
import * as type from './types';

export function sendMessage(data) {
    return {
        type: type.POST_SEND_MESSAGE_REQUESTED,
        data: data,
    }
}